const Genesis = require("../Genesis.js")
import { PreLoadHelper } from '../Helpers/helpers';
import 'jquery-ui';
import { Modal } from 'bootstrap';
import { QRCodeScanner } from "../Components/QRCodeScanner";
import { FieldProcessor, FilterDataManagerComponent } from '../Shared/FilterDataManager/FilterDataManagerComponent';
import Swal from "sweetalert2";
const { PropertyAutoComplete, PopulateLocationDropdown } = require("./assetsearch.js");

export class ISiteMobileAssetSearchAssetPage {
    private readonly startButton = document.getElementById('scanButton');
    private qrCodeScanner: QRCodeScanner | null = new QRCodeScanner;
    private qrNotFoundmodal: Modal | null = null;
    private readonly qrNotFoundModalElement = document.getElementById("qrNotFound-modal");
    private filterDataManager: FilterDataManagerComponent;
    constructor() {

        var propertyId = '-1';
        var locationId = '-1';
        const fieldProcessor: FieldProcessor = (fieldName, fieldValue) => {
            if (fieldName == "PropertyId") {
                propertyId = fieldValue
            }
            if (fieldName == "LocationId") {
                locationId = fieldValue
            }
            if (propertyId !== '-1' && fieldName == "LocationId") {
                PopulateLocationDropdown(propertyId, locationId);
            }
        };
        this.filterDataManager = new FilterDataManagerComponent('frmAssetSearch', fieldProcessor);
        this.filterDataManager.loadRetainedFilter();

        if (this.qrNotFoundModalElement !== null) {
            this.qrNotFoundmodal = new Modal(this.qrNotFoundModalElement, { backdrop: 'static', keyboard: false });
        }
    }

    public Init() {
        var that = this;
        $("#assetSearchbtn").click(function () {
            that.SearchAsset();
            that.filterDataManager.saveFormData();
        });

        $("#verificationSubmission").click(function () {
            that.SearchVerificationAsset();
            that.filterDataManager.saveFormData();
        });
        $('#modal-Scanner .modal-header a[data-bs-dismiss="modal"]').click(function () {
            that.qrCodeScanner?.stopScanning();
        });

        $("#genericassetSearchbtn").click(function () {
            that.SearchAsset();
            that.filterDataManager.saveFormData();
        });

        if (this.startButton) {
            this.startButton.addEventListener('click', async () => {
                await this.qrCodeScanner?.startScanning();
                const scannedCode = await this.qrCodeScanner?.scanBarcodeOrQRCode();
                if (scannedCode) {
                    var that = this;
                    that.qrCodeScanner?.stopScanning("Please Wait");
                    $.get(Genesis.url('/Asset/ISQRCodeLinkAvail'), {
                        QRCodeLink: scannedCode
                    }, function (responseResult) {
                        if (responseResult != null) {
                            var value = "Asset/ViewAssetDetail?RecordId=" + responseResult.recordID;
                            window.location.href = Genesis.url(value);
                        }
                        else {
                            localStorage.removeItem('ScannedCode');
                            localStorage.setItem('ScannedCode', scannedCode);
                            that.qrNotFoundmodal?.show();
                        }
                        that.qrCodeScanner?.stopScanning();
                    });
                }
            });
        }
        PropertyAutoComplete();
    }

    public SearchAsset() {
        var searchTerm = $("#assetSearch").val();
        var propertyid = $("#PropertyId").val();
        var locationid = $("#LocationId").val();

        var urlParams = new URLSearchParams(window.location.search);
        var isAssetVerification = urlParams.get("IsAssetVerification") === "true";

        $.ajax({
            type: "GET",
            url: "GetAssetsForSearch",
            dataType: "html",
            data: { searchTerm: searchTerm, propertyId: propertyid, locationId: locationid, isAssetVerification: isAssetVerification },
            success: function (data) {
                $("#filteredPlaceHolder").html(data);
            }
        });
    }

    public SearchVerificationAsset() {
        var searchTerm = $("#assetSearch").val();
        var propertyid = $("#PropertyId").val();
        var locationid = $("#LocationId").val();
        const self = this;
        $.ajax({
            type: "GET",
            url: "GetAssetsVerificationForSearch",
            dataType: "html",
            data: { searchTerm: searchTerm, propertyId: propertyid, locationId: locationid },
            success: function (data) {
                $("#filteredPlaceHolder").html(data);
                $(".verificationbtn").on("click", function (event) {
                    event.preventDefault();
                    const id = $(this).data("id");
                   self.handleVerificationSubmit(id);
                });

                $(".cancelbtn").on("click", function (event) {
                    event.preventDefault();
                    const id = $(this).data("id");
                    self.handleCancel(id);
                });
            }
        });
    }

    public handleVerificationSubmit(id: number): void {
        const self = this;
        $.ajax({
            type: "POST",
            url: "VerificationSubmit",
            dataType: "json",
            data: { Id: id},
            success: function () {
                Swal.fire({ text: `Submitted Successfully` });
                self.SearchVerificationAsset();
            }
        });
    }

    public handleCancel(id: number): void {
        $.ajax({
            type: "POST",
            url: "CancelSubmission",
            dataType: "json",
            data: { Id: id },
            success: function () {
                Swal.fire({ text: `Cancelled Successfully` });
                window.location.reload();
            }
        });
    }
};